export const ASSESSMENT_INVITATION_ERROR_CODES = Object.freeze({
	INVALID: 'ASSESSMENT_INVITATION_INVALID',
	EXPIRED: 'ASSESSMENT_INVITATION_EXPIRED',
	RECIPIENT_MISMATCH: 'ASSESSMENT_INVITATION_RECIPIENT_MISMATCH',
	DIFFERENT_ORGANIZATION: 'ASSESSMENT_INVITATION_DIFFERENT_ORGANIZATION'
})

const LANDING_STATE_BY_ERROR_CODE = Object.freeze({
	[ASSESSMENT_INVITATION_ERROR_CODES.INVALID]: 'invalid',
	[ASSESSMENT_INVITATION_ERROR_CODES.EXPIRED]: 'expired',
	[ASSESSMENT_INVITATION_ERROR_CODES.RECIPIENT_MISMATCH]: 'invalid',
	[ASSESSMENT_INVITATION_ERROR_CODES.DIFFERENT_ORGANIZATION]:
		'different-organization'
})

export function assessmentInvitationPath(token) {
	return `/assessment-invitation/${token}`
}

export function teamAssessmentPath(jobOfferId) {
	return `/assessment/job-offer/${jobOfferId}?mode=team`
}

export function teamAssessmentHandoffPath(query = {}) {
	const id = query.assessment_job
	return typeof id === 'string' &&
		/^[1-9]\d*$/.test(id) &&
		Number.isSafeInteger(Number(id))
		? teamAssessmentPath(id)
		: null
}

export function invitationHandoffPath(query = {}) {
	const id = query.job_offer
	if (
		typeof id === 'string' &&
		/^[1-9]\d*$/.test(id) &&
		Number.isSafeInteger(Number(id))
	) {
		const organizationId = query.organization_id
		const context =
			typeof organizationId === 'string' &&
			/^[1-9]\d*$/.test(organizationId) &&
			Number.isSafeInteger(Number(organizationId))
				? `?organization_id=${organizationId}`
				: ''
		return `/job-offer/${id}/view/job-profile${context}`
	}
	return teamAssessmentHandoffPath(query)
}

export function invitationMembershipPath(query = {}) {
	if (
		typeof query.invitation !== 'string' ||
		!/^[a-f0-9-]{36}$/i.test(query.invitation)
	)
		return null
	const membership = `/invitation/${query.invitation}/accept`
	const destination = invitationHandoffPath(query)
	if (!destination) return membership
	if (destination.startsWith('/job-offer/')) {
		const context = destination.split('?')[1]
		return `${membership}?job_offer=${query.job_offer}${
			context ? `&${context}` : ''
		}`
	}
	return `${membership}?assessment_job=${query.assessment_job}`
}

export function landingStateForError(error) {
	const code = error?.response?.data?.code
	return LANDING_STATE_BY_ERROR_CODE[code] || 'error'
}

export function isTeamAssessmentMode(route) {
	return route?.query?.mode === 'team'
}

export function isTeamAssessmentRoute(route) {
	return (
		isTeamAssessmentMode(route) &&
		/^\/assessment\/job-offer\/[^/]+\/?$/.test(route.path || '')
	)
}

export function assessmentRegistrationRoute(context, assessmentToken) {
	return {
		path: '/auth/register',
		query: {
			type: 'organization_member',
			token: context.organization_invitation_token,
			assessment: assessmentToken,
			email: context.email
		}
	}
}

export function assessmentLoginRoute(assessmentToken) {
	return {
		path: '/auth/login',
		query: {
			redirect: assessmentInvitationPath(assessmentToken)
		}
	}
}
